// pages/FailedPayment.jsx
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const FailedPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // دریافت پارامترهای Query String
  const queryParams = new URLSearchParams(location.search);
  const errorType = queryParams.get('error') || 'unknown_error';
  const refId = queryParams.get('ref_id');
  const packageId = queryParams.get('package_id');
  
  // پیام‌های خطا بر اساس نوع
  const errorMessages = {
    'payment_canceled': 'پرداخت توسط کاربر لغو شد.',
    'server_error': 'خطا در سرور پرداخت. لطفاً مجدداً تلاش کنید.',
    'timeout': 'مهلت پرداخت به پایان رسید.',
    'insufficient_funds': 'موجودی حساب کافی نیست.',
    'card_error': 'اطلاعات کارت بانکی صحیح نیست.',
    'unknown_error': 'خطای ناشناخته در پرداخت. با پشتیبانی تماس بگیرید.'
  };
  
  const errorMessage = errorMessages[errorType] || errorMessages['unknown_error'];

  useEffect(() => {
    // برای تست روی لوکال‌هاست، این بخش را موقتاً غیرفعال کنید
    // const token = localStorage.getItem('accessToken');
    // if (!token) {
    //   navigate('/login', { replace: true });
    // }
    
    console.log('🔴 Payment Error Page Loaded');
    console.log('Error Type:', errorType);
    console.log('Ref ID:', refId);
    console.log('Package ID:', packageId);
    console.log('Full URL:', window.location.href);
  }, [errorType, refId, packageId]);

  const styles = {
    container: {
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#f8f9fa',
      padding: '20px',
      margin: 0,
     
    },
    card: {
      maxWidth: '500px',
      width: '100%',
      backgroundColor: 'white',
      padding: '40px',
      borderRadius: '12px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
      textAlign: 'center'
    },
    iconWrapper: {
      width: '80px',
      height: '80px',
      borderRadius: '50%',
      backgroundColor: '#fee',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 20px'
    },
    icon: {
      fontSize: '40px',
      color: '#dc3545'
    },
    title: {
      color: '#dc3545',
      marginBottom: '15px',
      fontSize: '28px'
    },
    subtitle: {
      color: '#6c757d',
      marginBottom: '25px',
      fontSize: '16px'
    },
    errorBox: {
      backgroundColor: '#f8d7da',
      border: '1px solid #f5c6cb',
      color: '#721c24',
      padding: '15px',
      borderRadius: '6px',
      marginBottom: '20px',
      
      textAlign: 'right',
      fontSize: '14px',
      lineHeight: '1.8'
    },
    infoText: {
      color: '#6c757d',
      fontSize: '13px',
      marginBottom: '8px'
    },
    buttonGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '10px',
      marginTop: '20px'
    },
    primaryButton: {
      backgroundColor: '#dc3545',
      color: 'white',
      border: 'none',
      padding: '12px 20px',
      borderRadius: '6px',
      fontSize: '16px',
      cursor: 'pointer',
      transition: 'background-color 0.2s',
      width: '100%'
    },
    outlineButton: {
      backgroundColor: 'transparent',
      color: '#6c757d',
      border: '1px solid #6c757d',
      padding: '12px 20px',
      borderRadius: '6px',
      fontSize: '16px',
      cursor: 'pointer',
      transition: 'all 0.2s',
      width: '100%'
    },
    footer: {
      marginTop: '25px',
      paddingTop: '20px',
      borderTop: '1px solid #e9ecef',
      color: '#6c757d',
      fontSize: '12px'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.iconWrapper}>
          <span style={styles.icon}>❌</span>
        </div>
        
        <h2 style={styles.title}>پرداخت ناموفق</h2>
        <p style={styles.subtitle}>متأسفانه پرداخت شما با مشکل مواجه شده است.</p>
        
        <div style={styles.errorBox}>
          <div><strong>خطا:</strong> {errorMessage}</div>
          {refId && <div><strong>شماره مرجع:</strong> {refId}</div>}
          {packageId && <div><strong>شناسه بسته:</strong> {packageId}</div>}
         
        </div>
        
        <p style={styles.infoText}>
          لطفاً اطلاعات کارت بانکی خود را بررسی کرده و مجدداً تلاش کنید.
        </p>
        <p style={styles.infoText}>
          در صورت کسر مبلغ از حساب شما، تا ۷۲ ساعت آینده به حساب شما بازگردانده می‌شود.
        </p>
        
        <div style={styles.buttonGroup}>
          <button 
            style={styles.primaryButton}
            onClick={() => window.history.back()}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#c82333'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#dc3545'}
          >
            🔄 تلاش مجدد
          </button>
          
          <button 
            style={styles.outlineButton}
            onClick={() => navigate('/course')}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#6c757d';
              e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6c757d';
            }}
          >
             بازگشت به دوره‌ها
          </button>
          
          <button 
            style={styles.outlineButton}
            onClick={() => navigate('/')}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#6c757d';
              e.target.style.color = 'white';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = 'transparent';
              e.target.style.color = '#6c757d';
            }}
          >
             صفحه اصلی
          </button>
        </div>
        
        <div style={styles.footer}>
          برای دریافت راهنمایی بیشتر با پشتیبانی تماس بگیرید.
        </div>
      </div>
    </div>
  );
};

export default FailedPayment;